<template>
    <div class="profile-container">

        <div class="personal-info ">
            <div class="content-holder">
                <img :src='dummy_profile' alt="" class="profile-pic"/>
                <div class="profile-details">

                    <div v-if="!editMode" class="name-edit">
                        <h1 class="name">{{getUserProfile.first_name}} {{getUserProfile.last_name}}
                        <span @click="toggleEditMode()" class="edit-profile" > <b-icon icon="pencil" type="is-primary" class="edit-profile-icon"> </b-icon> </span>
                        </h1>
                    </div>

                    <div v-else class="edit-first-last-name">
                        <input  v-model="modifiedProfile.first_name" type="text" placeholder="First Name" maxlength="20"/>
                        <input v-model="modifiedProfile.last_name" type="text" placeholder="Last Name" maxlength="20"/>
                        <span  @click="saveProfile()" class="save-profile"> <b-icon icon="content-save" type="is-success"  size="is-large"> </b-icon> </span>
                    </div>

                    <div v-if="!editMode" class="profile-con">
                        <b-icon icon="information" type="is-info" class="profile-icon" > </b-icon>
                        <h1 v-if="this.getUserProfile.bio">{{getUserProfile.bio}}</h1>
                        <h1 v-else style="color:#999">Bio</h1>
                    </div>

                    <div v-else class="edit-user-bio">
                        <textarea v-model="modifiedProfile.bio"  placeholder="Bio" rows="3" maxlength="90"> </textarea>
                    </div>

                    <div class="profile-con">
                        <b-icon icon="at" type="is-success" class="profile-con-icon" > </b-icon>
                        <h1>{{getUserProfile.email}}</h1>
                    </div>

                    <div class="profile-con" style="justify-content: start;">
                        <b-icon icon="wallet" type="is-primary" class="profile-con-icon"  > </b-icon>
                        
                        <b-tooltip label="Ainak provide Two Access Types: Admin and User" class="accesstype" 
                                type="is-light" position="is-right">
                            <h1>{{getAccessType()}}</h1>
                            <!-- <i class="em em-question"></i> -->
                        </b-tooltip>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-info">
            <div class="total-models">
                <h2>MODELS</h2>
                <h1>{{getTotalModels}}</h1>
            </div>
            <div v-if="getAccessType() != 'User'" class="licenses-left">
                <h2>LICENSES LEFT</h2>
                <h1>{{getLicensesLeft}}</h1>
            </div>            
            <!-- <div  v-if="getAccessType() == 'Admin'" class="licenses-left">
                <h2>ACTIVE CHILDREN</h2>
                <h1>{{getActiveChildren}}</h1>
            </div> -->
            <div class="company">
                <h2>PLAN</h2>
                <h1>{{getAccessType()}}                </h1>
            </div>

            <!-- <div v-if="getAccessType() == 'User'" class="company">
                <h2>PLAN</h2>
                <h1>PRO Plan</h1>
            </div>
            <div v-if="getAccessType() == 'Admin'" class="company">
                <h2>PLAN</h2>
                <h1>SME Plan</h1>
            </div>
            <div v-if="getAccessType() == 'Super Admin'" class="company">
                <h2>PLAN</h2>
                <h1>Enterprise Plan</h1>
            </div> -->

            <!--<div class="remaining-storage">-->
                <!--<h2>FREE SPACE</h2>-->
                <!--<h1>1.2 GB</h1>-->
            <!--</div>-->
        </div>

        <div v-if="getAccessType() != 'User'" class="child-accounts">
            <!-- <div class="child-accounts" v-if="getUserChildProfiles.length > 0"> -->
            <h1 class="child-accounts-title stick-it ">Child Accounts</h1>
            <div class="listOfChildAccounts">

                <div class="individual-child-accounts" v-for="profile in getUserChildProfiles" :key="profile.first_name" >
                    <img :src='dummy_profile' alt="" class="child-profile-pic"/>
                    <h1 class="child-name">{{profile.first_name}} {{profile.last_name}}</h1>
                    <h2></h2>

                    <!-- <div class="child-prop">
                        <div class="child-proper" @click="Child_Activate_Deactivate()">
                            <div class="child-property child-tick">
                                <b-icon v-if="!childactive" icon="check" style="color:#aaa" class="tick cursor-pointer" > </b-icon>
                                <b-icon v-else icon="check" type="is-success" class="tick cursor-pointer" > </b-icon>
                            </div>                        
                        </div>
                        <div class="child-proper">
                            <div class="child-property">
                                <h2>8</h2>
                            </div>                                             
                        </div>
                        <div class="child-proper child-more">
                            <div class="child-property">
                                <span @click="confirmDeleteOneModel()"><b-icon icon="menu" type="is-info" class="actions cursor-pointer" > </b-icon></span>        
                            </div>                        
                        </div>
                        <div class="child-proper">
                            <div class="child-property child-more">
                                <span @click="confirmDeleteOneUser()"><b-icon icon="delete" type="is-danger" class="actions cursor-pointer" > </b-icon></span>        
                            </div>                        
                        </div>
                    </div> -->
                </div>

                <div  v-if="getLicensesLeft > 0" class="individual-child-accounts">
                    <img :src='img_add_child_account' alt="" class="child-profile-pic" @click="createProfile()"/>
                    <h1 class="child-name" @click="createProfile()">Add Account</h1>
                    <h2></h2>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "ProfileContent",
        data: function () {
            return {
                dummy_profile: require('@/assets/images/dummy-profile.png'),
                img_add_child_account: require('@/assets/images/img-add-child-account.png'),
                editMode: false,

                childactive: true,
                childrenactivecount:0,
                modifiedProfile: {
                    first_name: '',
                    last_name: '',
                    email:'',
                    bio:''
                },
                showModal: false,

            }
        }, computed:{
            getUserProfile(){

                // eslint-disable-next-line
                this.modifiedProfile.first_name = this.$store.state.userProfile.first_name;
                // eslint-disable-next-line
                this.modifiedProfile.last_name = this.$store.state.userProfile.last_name;
                // eslint-disable-next-line
                this.modifiedProfile.bio = this.$store.state.userProfile.bio;
                // eslint-disable-next-line
                this.modifiedProfile.email = this.$store.state.userProfile.email;

                return this.$store.state.userProfile;
            },
            getUserChildProfiles(){
                console.log(this.$store.state.userChildrenProfiles);
                return this.$store.state.userChildrenProfiles;
            },
            getLicensesLeft(){
                return this.$store.state.licensesLeft;
            },
            getActiveChildren(){
                return this.$store.state.licensesLeft - this.getUserChildProfiles.length;
            },
            getUserParentProfile(){
                return this.$store.state.userParentProfile;
            },
            getTotalModels(){
                return this.$store.getters.getTotalModels;
            }
        },
        mounted: function () {
            this.getProfile()
        },
        methods: {
            toggleEditMode() {
                this.editMode = true;
            },
            saveProfile() {
                this.$store.dispatch('updateUserProfile', this.modifiedProfile)
                    .then(() => {
                        console.log("hurry");
                        this.modifiedProfile.first_name = this.$store.state.userProfile.first_name;
                        this.modifiedProfile.last_name = this.$store.state.userProfile.last_name;
                        this.modifiedProfile.bio = this.$store.state.userProfile.bio;
                        this.modifiedProfile.email = this.$store.state.userProfile.email;
                    })
                    .catch(() => {
                        console.log("no hurry");
                    });
                this.editMode = false;
            },
            getProfile() {
                // getUserProfile
                this.$store.dispatch('getUserProfile')
                    .then(() => {
                        console.log("hurry");
                    }).catch(() => {

                    console.log("no hurry");
                })
            },

            getAccessType() {

                // if (this.getplan() === "Enterprise Plan")
                //     return 'Super Admin'
                // else if (this.getplan() === "SME Plan")
                //     return 'Admin'
                // //    return 'Company'
                // else if (this.getplan() === "PRO Plan")
                //     return 'User'


                if (this.$store.state.userProfile.access_type === 1)
                    return 'Super Admin'
                else if (this.$store.state.userProfile.access_type === 2)
                    return 'Admin'
                //    return 'Company'
                else if (this.$store.state.userProfile.access_type === 3)
                    return 'User'
                //    return 'Personal'

            },
            truncate(value, length) {
                return value.length > length
                    ? value.substr(0, length) + '...'
                    : value
            },
            createProfile(){
                this.$router.push('Register');
            },
            Child_Activate_Deactivate(){
                console.log("Child_Activate_Deactivate");
                if(this.childactive){
                    this.$dialog.confirm({
                        title: 'Dectivate',
                        message: 'Dectivate this user',
                        confirmText: 'Dectivate',
                        type: 'is-danger',
                        hasIcon: true,
                        onConfirm: () => {
                            this.childactive = !this.childactive,
                            console.log(this.childactive)
                        }
                    });
                }
                else{
                    this.$dialog.confirm({
                        title: 'Activate',
                        message: 'Activate this user',
                        confirmText: 'Activate',
                        type: 'is-success',
                        hasIcon: true,
                        onConfirm: () => {
                            this.childactive = !this.childactive,
                            console.log(this.childactive)
                        }
                    });
                }
            },
           
            confirmDeleteOneUser() {
                console.log("clicked on delete user!")
                this.$dialog.confirm({
                    title: 'Delete User',
                    message: 'This will delete all models and delete all user data',
                    confirmText: 'Delete',
                    type: 'is-danger',
                    hasIcon: true,
                    // onConfirm: () => this.deleteModel(row)
                });
            },

       }
   }
</script>

<style lang="scss" scoped>

    @import "@/assets/css/colors.scss";

    %top-padding-width-height {
        width: 100%;
        height: 100%;
        top: 0;
    }
    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .profile-container{
        @extend %top-padding-width-height;
        display: grid;
        grid-template-areas: "personal-info" "main-info" "child-accounts";
        grid-template-rows: 40% 20% 40%;
        grid-template-columns: 1fr;
        overflow: auto;
        margin:  0;

        .personal-info {
            grid-area: personal-info;
        }
        .main-info {
            grid-area: main-info;
        }
        .child-accounts {
            grid-area: child-accounts ;
            overflow-y: hidden;
            overflow-x: auto;
            white-space: nowrap;

            .individual-child-accounts{
                display: inline-block;
            }
        }
    }

    .personal-info {
        margin: 0;
        padding: 3% 0;

        .content-holder {
            width: 100%;
            height: 100%;
            @extend %flex-center-content;
            flex-direction: row;

            .profile-pic {
                width: 18%;
                height: auto;
                background-size: cover;
                border-radius: 50%;
                border: 1px solid $primary_color;
                align-self: center;
            }

            .profile-details {
                flex: 1;
                display: flex;
                justify-content: center;
                flex-direction: column;

                .name-edit {
                    @extend %flex-center-content;
                    flex-direction: row;
                    width: 100%;

                    h1 {
                        display: flex;
                        flex-direction: row;
                        flex: 1;
                        text-align: left;
                        font-family: 'Roboto Slab', sans-serif;
                        font-size: 200%;
                        font-weight: bold;
                        color: $primary-color;
                        padding: 0 3% 1% 3%;
                        
                        .edit-profile {
                            display: flex;
                            flex-direction: row;
                            flex: 1;
                            padding: 5px 0 0 2%;
                            justify-content: flex-start;
                            .edit-profile-icon{
                                justify-content: flex-start;
                                cursor: pointer;
                            }
                        }
                    }

                }

                .profile-con {
                    @extend %flex-center-content;
                    flex-direction: row;
                    padding-left: 3%;
                    padding-bottom: 2%;
                    width: 90%;

                    .profile-con-icon {
                    }

                    h1{
                        text-align: left;
                        width: 100%;
                        font-family: 'Roboto', sans-serif;
                        font-size: 100%;
                        color: $body-text-color;
                        padding-left: 1%;
                        flex: 1;
                    }
                    .accesstype{
                        text-align: left;
                        font-family: 'Roboto', sans-serif;
                        font-size: 100%;
                        color: $body-text-color;
                        padding-left: 1%;

                        h1{
                        text-align: left;
                        width: 100%;
                        font-family: 'Roboto', sans-serif;
                        font-size: 100%;
                        color: $body-text-color;
                        padding-left: 0;
                        flex: 1;
                    }
                    }
                }

                .edit-first-last-name {
                    @extend %flex-center-content;
                    flex-direction: row;
                    padding: 0 0 1% 2%;

                    input[type=text] {
                        flex: 1;
                        border: 1px solid #aaa;
                        border-radius: 10px;
                        outline: none;
                        padding: 1%;
                        box-sizing: border-box;
                        transition: 0.3s;
                        font-family: 'Roboto', sans-serif;
                        font-size: 100%;
                        letter-spacing: 1px;
                        margin-left: 1%;
                        width:30%;
                    }

                    input[type=text]:focus {
                        border-color: $primary-color;
                        box-shadow: 0 0 1px 0 $primary-color;
                    }

                    .save-profile {
                        margin: 0 5%;
                        cursor: pointer;
                    }
                }

                .edit-user-bio{
                    @extend %flex-center-content;
                    padding: 0 0 1% 2%;
                    width: 80%;

                    textarea {
                        flex: 1;
                        border: 1px solid #aaa;
                        border-radius: 10px;
                        outline: none;
                        padding: 1%;
                        box-sizing: border-box;
                        transition: 0.3s;
                        font-family: 'Roboto', sans-serif;
                        font-size: 100%;
                        letter-spacing: 1px;
                        margin-left: 1%;
                    }

                    textarea:focus {
                        border-color: $primary-color;
                        box-shadow: 0 0 1px 0 $primary-color;
                    }
                }
            }
        }
    }


    .main-info {
        border-top: 1px solid $border-sep-color;
        border-bottom: 1px solid $border-sep-color;
        @extend %flex-center-content;
        flex-direction: row;

        div {
            flex: 1;
            @extend %flex-center-content;
            flex-direction: column;
            border-right: 1px solid $border-sep-color;

            h2 {
                font-family: 'Roboto', sans-serif;
                font-size: 80%;
                font-weight: bold;
                color: $primary-color;
            }

            h1 {
                font-family: 'Roboto Slab', sans-serif;
                font-size: 200%;
                color: $body-text-color;
                margin-top: 2%;
                font-weight: lighter;

            }

            i{
                color:#555;
            }
        }

        div:last-child {
            border: none;
        }
    }


    .child-accounts {
        overflow-y: hidden;
        overflow-x: scroll;
        white-space: nowrap;
        text-align: left;


        .child-accounts-title {
            width: 100%;
            text-align: left;
            font-family: 'Roboto Slab', sans-serif;
            font-size: 150%;
            color: $primary-color;
            padding: 3% 0;
        }
        .listOfChildAccounts{
            overflow: auto;

            .individual-child-accounts {
                width: 200px;
                margin: 0 20px;
                display: inline-block;
                vertical-align: middle;
                // padding: 10px;
                text-align: center;
                border: 3px solid #e9430f1c;

                .child-profile-pic {
                    grid-area: child-profile-pic;
                    width: 50px;
                    height: 50px;
                    background-size: cover;
                    border-radius: 50%;
                    border: 1px solid $primary-color;
                    align-self: center;
                    margin: 10px 0;
                    cursor: pointer;
                }

                h1 {
                    grid-area: child-name;
                    font-family: 'Roboto', sans-serif;
                    font-size: 100%;
                    font-weight: bolder;
                    color: $primary-color;
                    margin: 0 0 10px 0;
                    cursor: pointer;
                }

                h2 {
                    font-family: 'Roboto', sans-serif;
                    font-size: 100%;
                    font-weight: bolder;
                    color: $primary-color;
                }

                .child-prop{
                    width: 100%;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    // background-color: #e9430f1c;
                    // border-bottom: 3px solid #e9430f1c;
                    border-top: 3px solid #e9430f1c;
                    
                    .child-proper{
                        width: 100%;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        -webkit-box-pack: center;
                        -ms-flex-pack: center;
                        justify-content: center;
                        
                        .child-property{
                            width: 100%;
                            margin:10px 0;

                            
                        }
                        .child-tick{
                            border-right: 3px solid #e9430f1c;
                        }
                        .child-more{
                            border-left: 3px solid #e9430f1c;
                        }
                    }
                }
            }
        }
    }


    .card-content{
        height:400px;

        .Subscription_Details{
            text-align: left;
            height: 20px;
            padding: 10px;
            .Subscription_Detail_Division{
                width: 90%;
                
                h2{
                    font-weight: 700;
                    font-size: 24px;
                }
                li{
                    margin: 12px 0;
                    
                    .item{
                        text-align: left;
                        font-weight: 700; 
                        text-transform: uppercase;
                    }
                    .item_detail{
                        text-align: right;
                        margin-left: 10px;
                    }
                    .state{
                        color: #fff;
                        background-color: #8ec165;
                        -moz-border-radius: 75px;
                        -webkit-border-radius: 75px;
                        padding: 2px 10px;
                    }
                    .trial{
                        background-color: #5bc0de;
                    }
                    .expired{
                        background-color: #d9534f;
                    }
                }
                .button{
                    color: $primary-color;
                    text-align: center;
                    width: 100%;
                    font-weight: 700;
                    border: 1px solid $primary-color;
                }
            }
        }
    
    }


    
    ol, ul {
        list-style: none;
    }
</style>